import {useState} from 'react';
import {Routes, Route} from 'react-router-dom';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';

import LoginPage from './LoginPage';
import AppModePage from './AppModePage';
import SessionCustomersPage from './SessionCustomersPage';
import NavBar from '../components/common/Nav/NavBar';

import DashboardPage from './DashboardPage';
import LoadListPage from './LoadListPage';
import LoadListDetailsPage from './LoadListDetailsPage';
import LoadListDetailsOwnershipPage from './LoadListDetailsOwnershipPage';
import LoadListDetailsManagePullsPage from './LoadListDetailsManagePullsPage';
import LoadListDetailsAddPinsPage from './LoadListDetailsAddPinsPage';
import LoadListDetailsProjectPage from './LoadListDetailsProjectPage';
import LoadListDetailsAdjustmentPage from './LoadListDetailsAdjustmentPage';
import LoadListAddPullPage from './LoadListAddPullPage';
import LoadListSetCrewPage from './LoadListSetCrewPage';
import LoadListMarkPage from './LoadListMarkPage';
import LoadListCompletePage from './LoadListCompletePage';
import LocatorPage from './LocatorPage';
import AnalyticsPage from './AnalyticsPage';
import ProjectsPage from './ProjectsPage';
import ProjectsPageEdit from './ProjectsPageEdit';
import CrewsPage from './CrewsPage';
import CrewsPageEdit from './CrewsPageEdit';
import ProductAliasPage from './ProductAliasPage';
import ProductAliasPageEdit from './ProductAliasPageEdit';
import CrewMembersPage from './CrewMembersPage';
import CrewMembersPageEdit from './CrewMembersPageEdit';
import PickupRequestsPage from './PickupRequestsPage';
import PickupRequestsPageEdit from './PickupRequestsPageEdit';
import NamedLocationsPage from './NamedLocationsPage';
import NamedLocationsPageEdit from './NamedLocationsPageEdit';
import CompanyProfilePageEdit from './CompanyProfilePageEdit';
import CompanyLinksPage from './CompanyLinksPage';
import CompanyLinksPageEdit from './CompanyLinksPageEdit';
import SuppliersPage from './SuppliersPage';
import SuppliersPageEdit from './SuppliersPageEdit'
import CustomerReelTypesPage from './CustomerReelTypesPage';
import CustomerReelTypesPageEdit from './CustomerReelTypesPageEdit';
import CustomerReelsPage from './CustomerReelsPage';
import CustomerReelsPageEdit from './CustomerReelsPageEdit';
import CustomerProductsPage from './CustomerProductsPage';
import CustomerProductsPageEdit from './CustomerProductsPageEdit';
import CustomerLoadsPage from './CustomerLoadsPage';
import CustomerLoadsPageEdit from './CustomerLoadsPageEdit';
import CustomerUsersPage from './CustomerUsersPage';
import CustomerUsersPageEdit from './CustomerUsersPageEdit';

import REPLoadsShippedLast30DaysPage from './analytics/REPLoadsShippedLast30DaysPage';
import REPLoadsReturnedLast30DaysPage from './analytics/REPLoadsReturnedLast30DaysPage';
import REPLoadsDueDetailPage from './analytics/REPLoadsDueDetailPage';
import REPLoadsAwaitingReturnPage from './analytics/REPLoadsAwaitingReturnPage';
import REPLoadsBatteryLevelPage from './analytics/REPLoadsBatteryLevelPage';
import REPLoadsProductRemainsDetailPage from './analytics/REPLoadsProductRemainsDetailPage';
import REPPullDetailsPage from './analytics/REPPullDetailsPage';

import UsersPage from './system/UsersPage';
import UsersPageEdit from './system/UsersPageEdit';
import CustomersPage from './system/CustomersPage';
import CustomersPageEdit from './system/CustomersPageEdit';
import ReelTypesPage from './system/ReelTypesPage';
import ReelTypesPageEdit from './system/ReelTypesPageEdit';
import TrackersPage from './system/TrackersPage';
import TrackersPageEdit from './system/TrackersPageEdit';
import ProductsPage from './system/ProductsPage';
import ProductsPageEdit from './system/ProductsPageEdit';
import ReelsPage from './system/ReelsPage';
import ReelsPageEdit from './system/ReelsPageEdit';
import LoadsPage from './system/LoadsPage';
import LoadsPageEdit from './system/LoadsPageEdit';
import SystemNamedLocationsPage from './system/SystemNamedLocationsPage';
import SystemNamedLocationsPageEdit from './system/SystemNamedLocationsPageEdit';
import PickupRequestsAdminPage from './system/PickupRequestsAdminPage';
import PickupRequestsAdminPageEdit from './system/PickupRequestsAdminPageEdit';
import BadShipmentsPage from './system/BadShipmentsPage';
import QrScanPage from './QrScanPage';

import ReelInspectionsPage from './ReelInspectionsPage';
import ReelInspectionsPageEdit from './ReelInspectionsPageEdit';

import InventoryDashboardPage from './inventory/InventoryDashboardPage';
import InventoryReelsPage from './inventory/InventoryReelsPage';
import InventoryReelsPageEdit from './inventory/InventoryReelsPageEdit';
import InventoryShipmentsPage from './inventory/InventoryShipmentsPage';

// import AssetsPage from './assets/AssetsPage';
// import AssetsPageEdit from './assets/AssetsPageEdit';
// import AssetTypesPage from './assets/AssetTypesPage';
// import AssetTypesPageEdit from './assets/AssetTypesPageEdit';


import PalletDashboardPage from './pallets/PalletDashboardPage';
import PalletsPage from './pallets/PalletsPage';
import PalletsPageEdit from './pallets/PalletsPageEdit';
import PalletPlantsPage from './pallets/PalletPlantsPage';
import PalletPlantsPageEdit from './pallets/PalletPlantsPageEdit';
import PalletActionPage from './pallets/PalletActionPage';
import PalletTurnsPage from './pallets/PalletTurnsPage';

import ManuReelsPage from './manufacturing/ManuReelsPage';
import ManuReelsPageEdit from './manufacturing/ManuReelsPageEdit';

import { useSessionContext } from '../contexts/SessionContext';

export default function Main( props ) {
  //console.debug("RTS Break Main");

  const [isModal, setIsModal] = useState(false);
  const {appMode, userAuthorized, sessionCustomer} = useSessionContext();

  if(!userAuthorized){
    return(<LoginPage 
              pwr={props.pwr==='1'?true:false}
              pwu={props.pwu===null?'':props.pwu} 
              pwt={props.pwt===null?'':props.pwt} 
            />);
  }


  if(appMode===null){
    return(
      <AppModePage />
    )    
  }


  if(sessionCustomer===null){
    return(
      <>
      <NavBar isModal={true} />
      <Toolbar id="sessionToolbar"></Toolbar>
      <Box id="mainBox" sx={{pt:2}}>
        <SessionCustomersPage />
      </Box>
      </>
    )
  }


  if(appMode==='REELS'){
    return(
      <>
      <NavBar isModal={isModal} />
      <Toolbar id="mainToolbar"></Toolbar>
      <Box id="mainBox" sx={{pt:2}}>
        <Routes>
          <Route path='/Dashboard' element={<DashboardPage filter={{customers:[sessionCustomer.customer]}} setIsModalFx={setIsModal}/>}/>
          <Route path='/LoadList' element={<LoadListPage setIsModalFx={setIsModal}/>}/>
          <Route path='/LoadListDetails' element={<LoadListDetailsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/LoadListDetailsOwnership' element={<LoadListDetailsOwnershipPage setIsModalFx={setIsModal}/>}/>
          <Route path='/LoadListDetailsManagePulls' element={<LoadListDetailsManagePullsPage setIsModalFx={setIsModal}/>}/>  
          <Route path='/LoadListDetailsAddPins' element={<LoadListDetailsAddPinsPage setIsModalFx={setIsModal}/>}/>  
          <Route path='/LoadListDetailsProject' element={<LoadListDetailsProjectPage setIsModalFx={setIsModal}/>}/>  
          <Route path='/LoadListDetailsAdjustment' element={<LoadListDetailsAdjustmentPage setIsModalFx={setIsModal}/>}/>  
          <Route path='/LoadListAddPull' element={<LoadListAddPullPage setIsModalFx={setIsModal}/>}/>
          <Route path='/LoadListSetCrew' element={<LoadListSetCrewPage setIsModalFx={setIsModal}/>}/>
          <Route path='/LoadListMark' element={<LoadListMarkPage setIsModalFx={setIsModal}/>}/>
          <Route path='/LoadListComplete' element={<LoadListCompletePage setIsModalFx={setIsModal}/>}/>
          <Route path='/Locator' element={<LocatorPage setIsModalFx={setIsModal}/>}/>
          <Route path='/Analytics' element={<AnalyticsPage setIsModalFx={setIsModal} tab={0} />}/> 
          <Route path='/Users' element={<UsersPage setIsModalFx={setIsModal}/>}/>
          <Route path='/UsersEdit' element={<UsersPageEdit  setIsModalFx={setIsModal}/>}/>
          <Route path='/Customers' element={<CustomersPage setIsModalFx={setIsModal}/>}/>
          <Route path='/CustomersEdit' element={<CustomersPageEdit  setIsModalFx={setIsModal} />}/>
          <Route path='/CompanyLinks' element={<CompanyLinksPage setIsModalFx={setIsModal}/>}/>
          <Route path='/CompanyLinksEdit' element={<CompanyLinksPageEdit  setIsModalFx={setIsModal} />}/>          
          <Route path='/CompanyProfileEdit' element={<CompanyProfilePageEdit setIsModalFx={setIsModal}/>}/>
          <Route path='/ReelTypes' element={<ReelTypesPage setIsModalFx={setIsModal}/>}/>
          <Route path='/ReelTypesEdit' element={<ReelTypesPageEdit  setIsModalFx={setIsModal}/>}/>
          <Route path='/Trackers' element={<TrackersPage setIsModalFx={setIsModal}/>}/>
          <Route path='/TrackersEdit' element={<TrackersPageEdit  setIsModalFx={setIsModal}/>}/>            
          <Route path='/Products' element={<ProductsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/ProductsEdit' element={<ProductsPageEdit  setIsModalFx={setIsModal}/>}/>  
          <Route path='/ProductAlias' element={<ProductAliasPage setIsModalFx={setIsModal}/>}/>
          <Route path='/ProductAliasEdit' element={<ProductAliasPageEdit  setIsModalFx={setIsModal}/>}/>  
          <Route path='/Reels' element={<ReelsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/ReelsEdit' element={<ReelsPageEdit  setIsModalFx={setIsModal}/>}/>                           
          <Route path='/Loads' element={<LoadsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/LoadsEdit' element={<LoadsPageEdit  setIsModalFx={setIsModal}/>}/>
          <Route path='/Projects' element={<ProjectsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/ProjectsEdit' element={<ProjectsPageEdit  setIsModalFx={setIsModal}/>}/>
          <Route path='/Crews' element={<CrewsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/CrewsEdit' element={<CrewsPageEdit  setIsModalFx={setIsModal}/>}/>
          <Route path='/CustomerReels' element={<CustomerReelsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/CustomerReelsEdit' element={<CustomerReelsPageEdit  setIsModalFx={setIsModal}/>}/>             
          <Route path='/CrewMembers' element={<CrewMembersPage setIsModalFx={setIsModal}/>}/>
          <Route path='/CrewMembersEdit' element={<CrewMembersPageEdit  setIsModalFx={setIsModal}/>}/>
          <Route path='/PickupRequests' element={<PickupRequestsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/PickupRequestsEdit' element={<PickupRequestsPageEdit setIsModalFx={setIsModal}/>}/>
          <Route path='/SystemNamedLocations' element={<SystemNamedLocationsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/SystemNamedLocationsEdit' element={<SystemNamedLocationsPageEdit  setIsModalFx={setIsModal}/>}/>                           
          <Route path='/PickupRequestsAdmin' element={<PickupRequestsAdminPage setIsModalFx={setIsModal}/>}/>
          <Route path='/PickupRequestsAdminEdit' element={<PickupRequestsAdminPageEdit  setIsModalFx={setIsModal}/>}/>
          <Route path='/QrScanPage' element={<QrScanPage  setIsModalFx={setIsModal}/>}/>
          <Route path='/REPLoadsShippedLast30DaysPage' element={<REPLoadsShippedLast30DaysPage setIsModalFx={setIsModal}/>}/>
          <Route path='/REPLoadsReturnedLast30DaysPage' element={<REPLoadsReturnedLast30DaysPage setIsModalFx={setIsModal}/>}/>
          <Route path='/REPLoadsDueDetailPage' element={<REPLoadsDueDetailPage setIsModalFx={setIsModal}/>}/>
          <Route path='/REPLoadsAwaitingReturnPage' element={<REPLoadsAwaitingReturnPage setIsModalFx={setIsModal}/>}/>
          <Route path='/REPLoadsBatteryLevelPage' element={<REPLoadsBatteryLevelPage setIsModalFx={setIsModal}/>}/>
          <Route path='/REPLoadsProductRemainsDetailPage' element={<REPLoadsProductRemainsDetailPage setIsModalFx={setIsModal}/>}/>
          <Route path='/REPPullDetailsPage' element={<REPPullDetailsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/NamedLocations' element={<NamedLocationsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/NamedLocationsEdit' element={<NamedLocationsPageEdit  setIsModalFx={setIsModal}/>}/>                           
          <Route path='/ReelInspectionsPage' element={<ReelInspectionsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/ReelInsepctionsPageEdit' element={<ReelInspectionsPageEdit  setIsModalFx={setIsModal}/>}/>                           
          <Route path='/Suppliers' element={<SuppliersPage setIsModalFx={setIsModal}/>}/>
          <Route path='/SuppliersEdit' element={<SuppliersPageEdit  setIsModalFx={setIsModal}/>}/> 
          <Route path='/CustomerReelTypes' element={<CustomerReelTypesPage setIsModalFx={setIsModal}/>}/>
          <Route path='/CustomerReelTypesEdit' element={<CustomerReelTypesPageEdit  setIsModalFx={setIsModal}/>}/>
          <Route path='/CustomerProducts' element={<CustomerProductsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/CustomerProductsEdit' element={<CustomerProductsPageEdit  setIsModalFx={setIsModal}/>}/>
          <Route path='/CustomerLoads' element={<CustomerLoadsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/CustomerLoadsEdit' element={<CustomerLoadsPageEdit  setIsModalFx={setIsModal}/>}/>
          <Route path='/BadShipmentsPage' element={<BadShipmentsPage  setIsModalFx={setIsModal}/>}/>
          <Route path='/CustomerUsers' element={<CustomerUsersPage setIsModalFx={setIsModal}/>}/>
          <Route path='/CustomerUsersEdit' element={<CustomerUsersPageEdit  setIsModalFx={setIsModal}/>}/>


          <Route path='*' replace={true} element={<DashboardPage UserAuthFx={props.UserAuthFx} filter={{customers:[sessionCustomer.customer]}} setIsModalFx={setIsModal}/>}/>
        </Routes>
      </Box>
      </>
    );
  }


  if(appMode==='MANUFACTURING'){
    return(
      <>
      <NavBar isModal={isModal} />
      <Toolbar id="mainToolbar"></Toolbar>
      <Box id="mainBox" sx={{pt:2}}>
        <Routes>
          <Route path='/ManuReelsPage' element={<ManuReelsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/ManuReelsPageEdit' element={<ManuReelsPageEdit  setIsModalFx={setIsModal}/>}/>                           
          <Route path='/Users' element={<UsersPage setIsModalFx={setIsModal}/>}/>
          <Route path='/UsersEdit' element={<UsersPageEdit  setIsModalFx={setIsModal}/>}/>
          <Route path='/ReelTypes' element={<ReelTypesPage setIsModalFx={setIsModal}/>}/>
          <Route path='/ReelTypesEdit' element={<ReelTypesPageEdit  setIsModalFx={setIsModal}/>}/>
          <Route path='/Trackers' element={<TrackersPage setIsModalFx={setIsModal}/>}/>
          <Route path='/TrackersEdit' element={<TrackersPageEdit  setIsModalFx={setIsModal}/>}/>            
          <Route path='/Reels' element={<ReelsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/ReelsEdit' element={<ReelsPageEdit  setIsModalFx={setIsModal}/>}/>                           
          <Route path='/PickupRequestsAdmin' element={<PickupRequestsAdminPage setIsModalFx={setIsModal}/>}/>
          <Route path='/PickupRequestsAdminEdit' element={<PickupRequestsAdminPageEdit  setIsModalFx={setIsModal}/>}/>
          <Route path='/ReelInspectionsPage' element={<ReelInspectionsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/ReelInsepctionsPageEdit' element={<ReelInspectionsPageEdit  setIsModalFx={setIsModal}/>}/>                           
          <Route path='/BadShipmentsPage' element={<BadShipmentsPage  setIsModalFx={setIsModal}/>}/>

          <Route path='*' replace={true} element={<ManuReelsPage UserAuthFx={props.UserAuthFx} filter={{customers:[sessionCustomer.customer]}} setIsModalFx={setIsModal}/>}/>
        </Routes>
      </Box>
      </>
    );
  }  


  if(appMode==='REELINSPECTIONS'){
    return(
      <>
      <NavBar isModal={isModal} />
      <Toolbar id="mainToolbar"></Toolbar>
      <Box id="mainBox" sx={{pt:2}}>
        <Routes>
          <Route path='/ReelInspectionsPage' element={<ReelInspectionsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/ReelInsepctionsPageEdit' element={<ReelInspectionsPageEdit  setIsModalFx={setIsModal}/>}/>                           
          <Route path='/Users' element={<UsersPage setIsModalFx={setIsModal}/>}/>
          <Route path='/UsersEdit' element={<UsersPageEdit  setIsModalFx={setIsModal}/>}/>
          <Route path='/ReelTypes' element={<ReelTypesPage setIsModalFx={setIsModal}/>}/>
          <Route path='/ReelTypesEdit' element={<ReelTypesPageEdit  setIsModalFx={setIsModal}/>}/>
          <Route path='/Trackers' element={<TrackersPage setIsModalFx={setIsModal}/>}/>
          <Route path='/TrackersEdit' element={<TrackersPageEdit  setIsModalFx={setIsModal}/>}/>            
          <Route path='/Reels' element={<ReelsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/ReelsEdit' element={<ReelsPageEdit  setIsModalFx={setIsModal}/>}/>                           
          <Route path='/PickupRequestsAdmin' element={<PickupRequestsAdminPage setIsModalFx={setIsModal}/>}/>
          <Route path='/PickupRequestsAdminEdit' element={<PickupRequestsAdminPageEdit  setIsModalFx={setIsModal}/>}/>

          <Route path='*' replace={true} element={<ReelInspectionsPage UserAuthFx={props.UserAuthFx} setIsModalFx={setIsModal}/>}/>
        </Routes>
      </Box>
      </>
    );
  }    


  if(appMode==='INVENTORY'){
    return(
      <>
      <NavBar isModal={isModal} />
      <Toolbar id="mainToolbar"></Toolbar>
      <Box id="mainBox" sx={{pt:2}}>
        <Routes>
          <Route path='/InventoryDashboard' replace={true} element={<InventoryDashboardPage UserAuthFx={props.UserAuthFx} filter={{customers:[sessionCustomer.customer]}} setIsModalFx={setIsModal}/>}/>
          <Route path='/InventoryReels' element={<InventoryReelsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/InventoryReelsEdit' element={<InventoryReelsPageEdit  setIsModalFx={setIsModal}/>}/>                           
          <Route path='/InventoryShipments' element={<InventoryShipmentsPage setIsModalFx={setIsModal}/>}/>

          <Route path='*' replace={true} element={<InventoryDashboardPage UserAuthFx={props.UserAuthFx} filter={{customers:[sessionCustomer.customer]}} setIsModalFx={setIsModal}/>}/>
        </Routes>
      </Box>
      </>
    );
  }


  if(appMode==='PALLETS'){
    return(
      <>
      <NavBar isModal={isModal} />
      <Toolbar id="mainToolbar"></Toolbar>
      <Box id="mainBox" sx={{pt:2}}>
        <Routes>
          <Route path='/PalletDashboard' element={<PalletDashboardPage setIsModalFx={setIsModal}/>}/>
          <Route path='/PalletTurns' element={<PalletTurnsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/Pallets' element={<PalletsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/PalletsEdit' element={<PalletsPageEdit  setIsModalFx={setIsModal}/>}/>
          <Route path='/PalletPlants' element={<PalletPlantsPage setIsModalFx={setIsModal}/>}/>
          <Route path='/PalletPlantsEdit' element={<PalletPlantsPageEdit  setIsModalFx={setIsModal}/>}/>
          <Route path='/PalletAction' element={<PalletActionPage setIsModalFx={setIsModal}/>}/>
          <Route path='/Users' element={<UsersPage setIsModalFx={setIsModal}/>}/>
          <Route path='/UsersEdit' element={<UsersPageEdit  setIsModalFx={setIsModal}/>}/>

          <Route path='*' replace={true} element={<PalletDashboardPage UserAuthFx={props.UserAuthFx} filter={{customers:[sessionCustomer.customer]}} setIsModalFx={setIsModal}/>}/>
        </Routes>
      </Box>
      </>
    );
  }


}
